import React from 'react';
import { BloodScreeningTable } from '../BloodScreeningTable/BloodScreeningTable';
import * as S from './BloodScreeningCard.styles';

interface IBloodScreeningCardProps {
  ActiveItem: string;
  // eslint-disable-next-line
  rawData: any;
}

export const BloodScreeningCard: React.FC<IBloodScreeningCardProps> = ({ ActiveItem, rawData }) => {
  return (
    <S.BloodScreeningCard padding={0}>
      {/* <BloodScreeningChart data={activeItem.yearData} /> */}
      <BloodScreeningTable ActiveItem={ActiveItem} rawData={rawData} />
    </S.BloodScreeningCard>
  );
};
